import { getModuleIcon } from '@/utils/moduleIcons';

interface TestMetric {
    label: string;
    value: string | number;
}

interface CognitiveFitnessProps {
    name: string;
    description: string;
    moduleDefinitionIdentifier?: string;
    result: TestMetric[];
}

const CognitiveFitness = ({ name, description, moduleDefinitionIdentifier, result }: CognitiveFitnessProps) => {
    const IconComp = moduleDefinitionIdentifier ? getModuleIcon(moduleDefinitionIdentifier) : null;

    return (
        <div className="rounded-lg bg-teal-100 p-5">
            <div className="flex flex-col gap-5">
                <div className="flex flex-1 flex-col gap-5">
                    <div className="flex items-center gap-2.5">
                        {IconComp && (
                            <IconComp className="h-5 w-5 shrink-0 text-teal-600" strokeWidth={2} aria-hidden="true" />
                        )}
                        <h4 className="text-base leading-6 font-semibold text-gray-900">{name}</h4>
                    </div>
                    <p className="text-base leading-6 font-medium text-slate-500">{description}</p>
                </div>
                <div className="flex flex-1 gap-5">
                    {result.map((metric, idx) => (
                        <div
                            key={idx}
                            className="flex flex-1 flex-col items-center justify-center gap-5 rounded-lg bg-white p-5"
                        >
                            <div className="flex flex-col items-center gap-2.5">
                                <div className="text-center text-xs leading-[18px] font-medium text-slate-500">
                                    {metric.label}
                                </div>
                                <div className="text-center text-xl leading-7 font-bold text-gray-900">
                                    {metric.value}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CognitiveFitness;
